var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Survey-1",
    transform: "translate(-1464.000000, -792.000000)",
    fill: "#1E87F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41-Copy-2",
    transform: "translate(1432.000000, 771.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8832206,22.5072576 L46.1619299,21.0764839 C46.0945983,21.0208822 46.0086004,20.997607 45.9186026,21.0001932 C45.8306048,21.0066585 45.7486068,21.0473899 45.6912749,21.1133361 L39.9980828,27.6116223 L34.3088906,21.1133361 C34.2508921,21.0473899 34.1688941,21.0066585 34.0808963,21.0001932 C33.9955651,20.9982536 33.9049007,21.0208822 33.837569,21.0764839 L32.1162784,22.5072576 C32.0489467,22.5635059 32.0076144,22.6430292 32.0009479,22.7290179 C31.9942814,22.8150065 32.0229474,22.8990556 32.0816126,22.9643553 L39.7467557,31.5548168 C39.8100875,31.6252887 39.9020852,31.6666667 39.9987495,31.6666667 C40.0954138,31.6666667 40.1874115,31.6259352 40.2507432,31.5548168 L47.918553,22.9643553 C47.9765516,22.8990556 48.0052175,22.8150065 47.9992177,22.7290179 C47.9932178,22.6430292 47.9505522,22.5635059 47.8832206,22.5072576 Z",
    id: "arrow-down"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlue);
export default __webpack_public_path__ + "static/media/arrow-down-blue.8d0ddcd03583488f1f4ecebb0778c637.svg";
export { ForwardRef as ReactComponent };